<template>
  <div id="app" class="router-view-box show-flex-box-c">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {
    this.pageAdaptiveSize(1920);
    // this.reqUserInfo();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    pageAdaptiveSize(designWidth) {
      var doc = document;
      var win = window;
      var docEl = doc.documentElement;
      var remStyle = document.createElement("style");
      var tid;

      var refreshRem = function() {
        var width = docEl.getBoundingClientRect().width;
        if (width > 1920) {
          var rem = (1920 * 100) / designWidth;
        } else if (width > 1680 && width <= 1920) {
          var rem = (1680 * 100) / designWidth;
        } else if (width > 1366 && width <= 1680) {
          var rem = (1366 * 100) / designWidth;
        } else if (width > 1280 && width <= 1366) {
          var rem = (1280 * 100) / designWidth;
        } else if (width > 1024 && width <= 1280) {
          var rem = (1024 * 100) / designWidth;
        } else if (width > 960 && width <= 1024) {
          var rem = (960 * 100) / designWidth;
        } else if (width > 800 && width <= 960) {
          var rem = (800 * 100) / designWidth;
        } else if (width <= 800) {
          var rem = (800 * 100) / designWidth;
        }
        remStyle.innerHTML = "html{font-size:" + rem + "px;}";
      };

      if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(remStyle);
      } else {
        var wrap = doc.createElement("div");
        wrap.appendChild(remStyle);
        doc.write(wrap.innerHTML);
        wrap = null;
      }

      //要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
      refreshRem();

      win.addEventListener(
        "resize",
        function() {
          clearTimeout(tid); //防止执行两次
          tid = setTimeout(refreshRem, 300);
        },
        false
      );

      win.addEventListener(
        "pageshow",
        function(e) {
          if (e.persisted) {
            // 浏览器后退的时候重新计算
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
          }
        },
        false
      );

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = "16px";
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function(e) {
            doc.body.style.fontSize = "16px";
          },
          false
        );
      }
    },

    reqUserInfo: function() {
      this.$store.dispatch("reqUpdateUserInfo");
    }
  }
};
</script>
<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
}
.router-view-box {
  width: 100%;
  height: 100%;
  // max-width: 1920px;
  // max-height: 1080px;
  min-width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue